import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {Tab} from '../Tab';
import {Document} from "../../models/Document";
import {DocumentsStructureTree} from "./DocumentsStructureTree";
import {documentsStructure} from "./definitions/Structure";
import {Folder} from "../../models/Folder";
import {actionDocumentFetchAll} from "../../store/documents";
import {actionFolderFetchAll, actionSaveExpandedNodes} from "../../store/folders";
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails";
import {LookupDataRow} from "../../services/LookupDataRow";
import {Customer} from "../../models/Customer";
import {Department} from "../../models/Department";
import {Position} from "../../models/Position";
import {Employee} from "../../models/Employee";
import {actionDepartmentsFetchAll} from "../../store/departments";
import {actionPositionFetchAll} from "../../store/positions";
import {actionEmployeeFetchAll} from "../../store/employees";

export interface DocumentsTabProps {
	documents: Document[]
	folders: Folder[]
	departments: Department[]
	positions: Position[]
	employees: Employee[]
	customers: Customer[]
	tab: Tab
	expandedNodeIds: string[]
}

export interface DocumentsTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		documents: state.documents.list,
		folders: state.folders.list,
		departments: state.departments.list,
		positions: state.positions.list,
		employees: state.employees.list,
		customers: state.customers.list,
		tab: state.tabs.active,
		expandedNodeIds: state.folders.expandedNodes
	};
}

class DocumentsTab extends React.Component<DocumentsTabProps, DocumentsTabState> {

	constructor(props: DocumentsTabProps) {
		super(props)
	}

	componentDidMount() {
		this.loadData()
	}

	componentWillMount() {
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
			</div>
		);
	}

	renderForm(): React.ReactNode {

		return (<div className="create-form" style={{overflow: "scroll", minHeight: 500}}>
			<DocumentsStructureTree
				structure={documentsStructure}
				documents={this.props.documents}
				folders={this.props.folders}
				setExpanded={this.setExpandedNodes}
				expandedNodeIds={this.props.expandedNodeIds}
				lookupData={this.getLookupData.bind(this)}
			/>
		</div>)
	}

	private loadData() {
		actionDocumentFetchAll()
		actionFolderFetchAll()
		actionDepartmentsFetchAll()
		actionPositionFetchAll()
		actionEmployeeFetchAll()
	}

	private setExpandedNodes(nodeIds: any) {
		actionSaveExpandedNodes(nodeIds)
	}

	private getLookupData(lookupEntity: LookupEntities): LookupDataRow[] {
		switch (lookupEntity) {
			case LookupEntities.Departments: {
				return this.props.departments.map((department: Department) => {return {label: department.title, value: department.id, data: department}})
			}
			case LookupEntities.Positions: {
				return this.props.positions.map((position: Position) => {return {label: position.title, value: position.id, data: position}})
			}
			case LookupEntities.Employees: {
				return this.props.employees.map((employee: Employee) => {return {label: `${employee.firstName} ${employee.lastName}`, value: employee.id, data: employee}})
			}
			case LookupEntities.Customers: {
				return this.props.customers.map((customer: Customer) => {return {label: `${customer.title}`, value: customer.id, data: customer}})
			}
		}
	}

}

export default connect(mapStateToProps)(DocumentsTab);
